export default "__VITE_ASSET__BH_L8B_r__"